import {isNotNil} from 'ramda';

import {AuctionSourcingListItem} from './adaptAuctionVehicleToSourcingItem';

/**
 * Type guard: narrows an unknown row to AuctionSourcingListItem.
 * `auctionVehicle` exists on auction detail/list shapes and is absent from
 * SourcingVehicleListItemResponseBody, making it a reliable discriminant.
 */
export function isAuctionVehicle(row: unknown): row is AuctionSourcingListItem {
  if (!isNotNil(row) || typeof row !== 'object' || !('auctionVehicle' in row)) {
    return false;
  }

  return isNotNil(row.auctionVehicle);
}
